<template>
    <v-row v-if="!$store.getters.progress" class="ma-0 pb-offset">
        <revenue-chart
            class="pb-4"
            :model-id='id'
            model-key="company_id"
            url="suppliersrevenuestats"
            :entity-title="entityTitle"
        ></revenue-chart>                    
        <sold-products
            title="Prodotti Acquistati"
            :model-id='id'
            type="costs"
            url="purchaseproductsstats"
            model-key="company_id"
            :entity-title="entityTitle"
        ></sold-products>
    </v-row>
</template>

<script>
    import RevenueChart from '@/components/common/RevenueChart'
    import SoldProducts from '@/components/common/SoldProducts'

    export default {
		name: 'supplier-analytics',
		components: {
            SoldProducts,
            RevenueChart,
        },

        props: {
            id: Number,
            entityTitle: String,
        },

		created() {
            this.$store.commit('endProgress')
		},        
    }
</script>